var dictionary_index = [];
var dic = {
	posts: [],
	current: 0,
	countMax: 0,
	pageMax : 0,
	count: 6,
	canClick: true,
	init: function(){
		if(isLang === "en"){
			var indexurl = "/api/dictionary/en.json";
		}else{
			var indexurl = "/api/dictionary/ja.json";
		}
		
		let prm = {};
		load.getJson(indexurl, prm).done(function(json){
			dictionary_index = json.dictionary;
			$(".num_dictionary .max").html(json.count);
			dic.getCurrentNum();
		});
		$("#list_dictionary ul li").remove();
		dic.current = 0;
		let url = "/api/?type=dictionary";
		let param = {
			page : dic.current
		}

		load.getJson(url, param).done(function(json){
			dic.countMax 	= json.total;
			dic.count 		= json.count;
			dic.pageMax 	= Math.ceil( dic.countMax / dic.count );
			//console.log(json)
			dic.makeHTML(json);
			let prevURL = $("#btn_prev_dictionary").attr("href");
			let nextURL = $("#btn_next_dictionary").attr("href");
			dic.getPostURL(prevURL, nextURL);
		});
	},
	loadNext: function(){
		dic.current++;
		if(dic.current >= dic.pageMax){
			dic.current = dic.pageMax - 1;
			return false
		}
		$("body").addClass("loading_content");
		common.startLoading();
		let url = "/api/?type=dictionary";
		var param = {
			page: dic.current
		};
		load.getJson(url, param).done(function(json){
			dic.makeHTML(json);
		});
	},
	makeHTML: function(json){
		let HTML = '';
		let data = json.posts;
		dic.posts = data;

		let start 	= dic.current*dic.count;
		let end 	= start + dic.count;
		if(dic.current === dic.pageMax-1){
			end = dic.countMax;
		}
		console.log(json, start, end);
		let $count = 0;
		let imgArry = [];
		for(let i = start; i < end; i++){
			let d = data[$count];
			HTML 	+= '<li>'
					+ '<a href="' + d.url + '" title="' + d.title + '">'
					+ '<figure><img src="' + d.image2 + '" sizes="50vw" srcset="' + d.image + ' 320w, ' + d.image2 + ' 640w" alt="' + d.title + '"></figure>'
					+ '</a></li>';
			$count++;
			if(d.image2 != ""){
				imgArry.push(d.image2);
			}
		}
		preload.startLoad(imgArry.length,imgArry, true).done(function(){
			$("body").removeClass("loading_content");
			$("#list_dictionary ul").append(HTML);
			common.endLoading();
			dic.nav();
		});
	},
	nav: function(){
		$("#list_dictionary li a").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			dic.current = $("#list_dictionary li a").index(this);
			page.changeURL(url);

			$html.classList.add("dictionary");
			setTimeout(function(){
				$html.classList.add("show_dictionary");
			},50);
		});
		$("a.btn_return").off().on("click", function(){
			if(isLang === "en"){
				page.changeURL("/en/dictionary/");
			}else{
				page.changeURL("/dictionary/");
			}
			
		});
		$("a#btn_close_detail").off().on("click", function(){
			if($html.classList.contains("show_dictionary")){
				if(isLang === "en"){
					page.changeURL("/en/dictionary/");
				}else{
					page.changeURL("/dictionary/");
				}
			}
		});
		$("a#btn_prev_dictionary").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			if(dic.canClick){
				dic.canClick = false;
				page.changeURL(url);
			}
		});
		$("a#btn_next_dictionary").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			if(dic.canClick){
				dic.canClick = false;
				page.changeURL(url);
			}
		});
	},
	inc: function(){
		dic.current++;
		if(dic.current >= dic.countMax){
			dic.current = 0;
		}
		let url = dic.posts[dic.current].url;
		dic.loadPage(url);
	},
	dec: function(){
		dic.current--;
		if(dic.current < 0){
			dic.current = dic.countMax-1;
		}
		dic.loadPage();
	},
	loadPage: function(url){
		if($html.classList.contains("show_dictionary")){
			$("#detail_dictionary").addClass("disable");
			setTimeout(function(){
				$("#detail_dictionary_inner").animate({
					scrollTop : "0px"
				},{
					"duration" 	: 10
				});
				loadAndAdd();
			}, 600);
		}else{
			loadAndAdd();
		}
		function loadAndAdd(){
			$.get(url, {},function(data){
				var out_html 	= $(data),
					postTitle 	= $("header", out_html)[0];
				dic.changeContent(data).done(function(){
					dic.showPage();
				});
			});
		}
	},
	changeContent: function(data){
		var defer = $.Deferred();
		var out_html 	= $(data),
			ttl 		= out_html.filter("title")[0].innerHTML,
			$content 	= $("#detail_dictionary #load_content"),
			content 	= $("#load_content_inner", out_html)[0],
			postTitle 	= $("header", out_html)[0],
			$prev 		= $("#btn_prev_dictionary", out_html),
			$next 		= $("#btn_next_dictionary", out_html);
		$content.html(content);
		document.title = ttl;
		var links = out_html.filter("link");
		common.getLangURL(links);
		
		//現在が何番目かをjsonから取得するようにする
		$(".num_dictionary .max").html(dic.countMax);
		let prevURL = $prev.attr("href");
		let nextURL = $next.attr("href");
		dic.getPostURL(prevURL, nextURL);

		setTimeout(function(){
			dic.getCurrentNum();
			defer.resolve();
		},100);
		return defer.promise();
	},
	getPostURL: function(prevURL, nextURL){
		let $prev = $("#btn_prev_dictionary"),
			$next = $("#btn_next_dictionary");
		if(prevURL === ""){
			$prev.css("display", "none");
		}else{
			$prev.css("display", "block");
			$prev.attr("href", prevURL);
		}
		if(nextURL === ""){
			$next.css("display", "none");
		}else{
			$next.css("display", "block");
			$next.attr("href", nextURL);
		}
	},
	showPage: function(){
		if($html.classList.contains("show_content")){
			$("#detail_dictionary").addClass("show");
			dic.nav();
			setTimeout(function(){
				dic.canClick = true;
				$("#detail_dictionary").removeClass("show disable");
			},600);
		}else{
			setTimeout(function(){
				$html.classList.add("show_content");
				setTimeout(function(){
					dic.canClick = true;
					dic.nav();
				},600);
			}, 400);
		}
	},
	closePage: function(){
		$html.classList.add("close_dictionary");
		$html.classList.remove("show_content");
		setTimeout(function(){
			$html.classList.remove("show_dictionary");
			var ttl = $("h1 a").text();
			document.title = "THE DICTIONARY | " + ttl;
			setTimeout(function(){
				$html.classList.remove("dictionary");
				$html.classList.remove("close_dictionary");
			}, 600);
		},600);
	},
	getCurrentNum: function(){
		let data = dictionary_index;
		let path = location.pathname;
		for(var i = 0; i < data.length; i++){
			let url 	= data[i].url;
			if(path === url){
				$(".num_dictionary .current").html(data[i].p)
			}
		}
	}
}